import React from 'react';
import { useIntl, history } from 'umi';
import {
  datamapIntelligenceSourcesPath,
  datamapOpinionsMetricsPath,
} from '@/pages/intelligence/utils/common';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';

export function Content(props: {
  showMobileDataSourceRangeInfo?: boolean;
  title: 'sum' | (string & {});
}) {
  const { showMobileDataSourceRangeInfo = false, title } = props;
  const { formatMessage } = useIntl();
  let tip: React.ReactNode = '';
  switch (title) {
    case 'sum':
      tip = formatMessage({ id: 'dbi_info_sum_selected' });
      break;
    default:
      tip = '';
      break;
  }
  return (
    <>
      {tip}
      {showMobileDataSourceRangeInfo && (
        <>
          <br />
          {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
        </>
      )}
    </>
  );
}

export const CBSvgIconTips = (props) => {
  const { formatMessage } = useIntl();
  const { source = '' } = props;
  return (
    <span>
      {formatMessage({ id: 'dbi_company_cb_info_tips' })}
      <span
        onClick={() => {
          history.push({
            pathname: datamapIntelligenceSourcesPath,
            query: {
              sourceValue: source || '',
            },
          });
          // history.push(datamapIntelligenceSourcesPath);
        }}
        style={{ color: '#006eff', cursor: 'pointer', paddingLeft: '5px' }}
      >
        {formatMessage({ id: 'dbh_learnmore' })}
      </span>
    </span>
  );
};

export const SimpleTextInfoTips = (props: { intlKey: string }) => {
  const { intlKey } = props;
  const { formatMessage } = useIntl();
  if (!intlKey) return null;
  return <>{formatMessage({ id: intlKey })}</>;
};

export const DownloadsInfoTips = (props: { intlKey: string; dataSource?: string }) => {
  const { formatMessage } = useIntl();
  const { intlKey, dataSource } = props;
  return (
    // eslint-disable-next-line prettier/prettier
    <span>{formatMessage({ id: intlKey })}<img src={getDataSourceIcon(dataSource || 'appannie')} alt="" />{dataSource === 'sensortower' ? 'Sensor Tower.' : 'data.ai.'}<span style={{ color: '#326FF0' }}>{formatMessage({ id: 'dbh_learnmore' })}</span></span>
  );
};

export const MentionsInfoTips = (props: { intlKey: string }) => {
  const { formatMessage } = useIntl();
  const { intlKey } = props;
  return (
    // eslint-disable-next-line prettier/prettier
    <span>{formatMessage({ id: intlKey })}Opinion舆情.<span style={{ color: '#326FF0', cursor: 'pointer' }} onClick={(e) => {
          e?.stopPropagation();
          e?.preventDefault();
          history.push(datamapOpinionsMetricsPath);
        }}
      >
        {formatMessage({ id: 'dbh_learnmore' })}
      </span>
    </span>
  );
};
